// PermitsComponent.js
import { useEffect, useState } from 'react';
import ModalUploadFileLog from 'shared/components/uploadFileModal/uploadFileModal';
import { FileLabel } from 'shared/types/file';
import { fetchWithAuth } from 'shared/api/fetch-with-auth';
import { API_URL } from 'constants/index';
import { useSession } from '@clerk/clerk-react';
import { PermitDTO } from 'shared/types/regulatory-info';
import FileLogTable from 'shared/components/uploadFileModal/fileLogTable';

const PermitsComponent = ({ buildingRegulatoryInfoId, unit, building }: any) => {
    const [permits, setPermits] = useState<PermitDTO[]>([]);
    const [fileModalOpen, setFileModalOpen] = useState(false);
    const { session } = useSession();

    const fetchPermits = async () => {
        const res = await fetchWithAuth(`${API_URL}/building/permits/${buildingRegulatoryInfoId}`, { method: 'GET' }, session)
        setPermits(await res.json());
    }

    useEffect(() => {
        if (buildingRegulatoryInfoId) fetchPermits();
    }, [buildingRegulatoryInfoId])

    const handleOpenAddPermitModal = () => {
        setFileModalOpen(true);
    };

    const handleFileModalClose = () => {
        setFileModalOpen(false);
    };

    const handleFileModalSave = async (fileLogData: any) => {
        const newPermit = fileLogData.customData?.permit;
        if (newPermit) {
            setPermits([...permits, newPermit]);
        }
        handleFileModalClose();
    };

    return (
        <>
            <div className="col-span-full mt-8 flex flex-col gap-3">
                <FileLogTable
                    acceptedLabels={[FileLabel.Omgevingsvergunning, FileLabel.Milieuvergunning, FileLabel.ConformiteitsattestStedenbouw, "Watertoets", "Erfgoedinfo", "PV overtreding stedenbouw"]}
                    onUploadClick={handleOpenAddPermitModal}
                    building={building}
                />
            </div>
            {fileModalOpen && (
                <ModalUploadFileLog
                    isOpen={fileModalOpen}
                    onClose={handleFileModalClose}
                    onSave={handleFileModalSave}
                    incomingCustomData={{ buildingRegulatoryInfoId }}
                    customLabels={[FileLabel.Omgevingsvergunning, FileLabel.Milieuvergunning, FileLabel.ConformiteitsattestStedenbouw]}
                    defaultFileLabel={FileLabel.Omgevingsvergunning}
                    unit={unit}
                    building={building}
                />
            )}
        </>
    );
};

export default PermitsComponent;
